import { PropsWithChildren, useLayoutEffect } from 'react'

import { LayoutTheme, useAppActions } from '@store'

type Props = {
  layoutTheme: LayoutTheme
}

export const LayoutWrapper = ({
  children,
  layoutTheme,
}: PropsWithChildren<Props>) => {
  const { setThemeColor } = useAppActions()

  useLayoutEffect(() => {
    setThemeColor(layoutTheme)
  })

  return <>{children}</>
}
